import React, { Fragment, memo } from 'react';
import { Button, Col, Row, Typography } from 'components';
import { DeleteIcon, EditIcon, OutlineArrowDownIcon, OutlineArrowUpIcon } from 'components/common/icons';
import { SHIPPING_METHOD_MAPPING } from 'feature/clientTabs/shipping/shippingAddresses/shippingAddress';
import { SHIPPING_MEASUREMENT_RANGE_MAPPING, SHIPPING_RATE_METRICS_MAPPING } from 'staticData/form/client/shipping';
import styles from 'feature/countryTabs/shipping/cityShippingRates/styles.module.scss';
import { SpecialRate } from 'feature/countryTabs/shipping/cityShippingRates/index';
import { HasAccess } from 'components/common/accessControl';
import { PERMISSIONS } from 'constants/permissions';
import { useShippingRateCard } from 'feature/countryTabs/shipping/shippingRates/shippingRateCard/useShippingRateCard';

const { Text } = Typography;
export const CityShippingRateCard = memo<{
  specialRate: SpecialRate;
  onHandleEdit: (i: SpecialRate) => void;
  onHandleDelete: (i: SpecialRate) => void;
}>(({ specialRate, onHandleEdit, onHandleDelete }) => {
  const { isSeeAllVisible, isAllShown, onShowAllStateChange, priceList } = useShippingRateCard({
    prices: specialRate.prices || [],
  });
  return (
    <>
      <Col className={`${styles.special_rate_card} ${styles.city}`} span={24}>
        <Row justify={'space-between'}>
          <Col>
            <Row align={'middle'} className={'gap-6'}>
              <Text style={{ fontWeight: 600, color: '#222530', fontSize: 14 }}>
                WAREHOUSE IN {specialRate.warehouse.name} - {specialRate.city}
              </Text>
            </Row>
          </Col>
          <Col>
            <HasAccess role={PERMISSIONS.countries.shipping_city_rate.delete}>
              <Button type={'link'} icon={<DeleteIcon />} onClick={() => onHandleDelete(specialRate)} />
            </HasAccess>
            <HasAccess role={PERMISSIONS.countries.shipping_city_rate.write}>
              <Button type={'link'} icon={<EditIcon />} onClick={() => onHandleEdit(specialRate)} />
            </HasAccess>
          </Col>
        </Row>
        <Row className={styles.shipping_details} justify={'space-between'}>
          <Col>
            {!!specialRate.shippingMethods?.length && (
              <Row className={styles.shipping_method_container} align={'middle'}>
                {specialRate.shippingMethods.map((_item) => {
                  return (
                    <Fragment key={_item}>
                      <Col className={styles.shipping_method}>{SHIPPING_METHOD_MAPPING[_item].icon}</Col>
                      <Col>
                        <Text style={{ color: '#222530' }}>{SHIPPING_METHOD_MAPPING[_item].text}</Text>
                      </Col>
                    </Fragment>
                  );
                })}
              </Row>
            )}
          </Col>
        </Row>
        {(priceList[0].metrics || priceList[0].measurementRange || priceList[0].price) && (
          <Row>
            <Col span={24}>
              <Text style={{ fontWeight: 600, color: '#222530', fontSize: 14 }} className={styles.price_title}>
                Price
              </Text>
            </Col>
            <Col span={24}>
              {priceList.map((price, index: number) => {
                return (
                  <Row className={styles.special_rate_price} key={index} justify={'space-between'}>
                    <Col>
                      <Text style={{ color: '#525866', fontSize: 14 }}>
                        {SHIPPING_RATE_METRICS_MAPPING[price.metrics]}:
                        {SHIPPING_MEASUREMENT_RANGE_MAPPING[price.measurementRange]}
                      </Text>
                    </Col>
                    <Col>
                      {price.price && (
                        <Text style={{ fontWeight: 500, color: '#525866', fontSize: 14 }}>{price.price} €</Text>
                      )}
                    </Col>
                  </Row>
                );
              })}
            </Col>
          </Row>
        )}
        {isSeeAllVisible && (
          <Col span={24}>
            <Row align={'middle'} justify={'end'}>
              <Col>
                <Button
                  type={'link'}
                  variant={'link'}
                  style={{
                    color: '#308D82',
                    textDecoration: 'underline',
                    padding: 0,
                    margin: 0,
                    fontSize: 14,
                    fontWeight: 400,
                  }}
                  onClick={onShowAllStateChange}
                >
                  {isAllShown ? 'See Less' : 'See All'}
                  {isAllShown ? (
                    <OutlineArrowUpIcon size={'sm'} color={'#308D82'} />
                  ) : (
                    <OutlineArrowDownIcon size={'sm'} color={'#308D82'} />
                  )}
                </Button>
              </Col>
            </Row>
          </Col>
        )}
      </Col>
    </>
  );
});
